import { Button, Cluster } from "@salesapp/ui";

/** Footer for a paged list: how many rows are showing, and a button when there are more. */
export function LoadMore({
  shown,
  total,
  hasMore,
  loading,
  onLoadMore,
  noun = "rows",
}: {
  shown: number;
  /** Matching rows in the whole list. Omit when the API did not count them. */
  total?: number | null;
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
  noun?: string;
}) {
  if (shown === 0) return null;
  const summary =
    total != null
      ? shown >= total
        ? `Showing all ${shown} ${noun}.`
        : `Showing ${shown} of ${total} ${noun}.`
      : hasMore
        ? `Showing the first ${shown} ${noun}.`
        : `Showing all ${shown} ${noun}.`;
  return (
    <Cluster gap={3} className="crm-load-more">
      <span className="crm-help" role="status">
        {summary}
      </span>
      {hasMore && (
        <Button variant="secondary" onClick={onLoadMore} disabled={loading}>
          {loading ? "Loading…" : "Load more"}
        </Button>
      )}
    </Cluster>
  );
}
